<button
  appButton="large-search"
  i18n-title
  id="addtofavourites-button"
  class="add-to-favorites-wrapper"
  title="Add to favourites"
  [disabled]="!serviceType || !searchService.searches[serviceType]?.isFavouriteValid.value"
  (click)="openModal()"
  i18n="@@addToFavourites"
  >Add to favourites</button
>
